import { useCallback, useEffect, useState } from 'react';
import './styles.scss';
import { motion } from "framer-motion";

const DivergenceItem = ({ item, setItem }) => {
    const [image, setImage] = useState({});
    const [secondImage, setSecondImage] = useState(null);
    const [folder, setFolder] = useState("divergence");

    useEffect(() => {

        if (item?.generalImagery?.length) {
            setImage(item.generalImagery[0]?.fileName)
            setSecondImage(null)

            if (item.generalImagery?.length > 1) {
                setSecondImage(item.generalImagery[1]?.fileName)
            }
        } else {
            const firstVariant = item.variants[0];

            setImage(firstVariant?.speciesGeneralImagery[0]?.fileName)
            setSecondImage(null)
            setFolder("divergenceSpecies")

            if (firstVariant?.speciesGeneralImagery?.length > 1) {
                setSecondImage(firstVariant.speciesGeneralImagery[1]?.fileName)
            }
        }
    }, [item])


    const imageHoverHandler = useCallback((image) => {
        if (image) {
            setImage(image)
        }
    }, [])

    const imageLeaveHandler = useCallback(() => {
        if (item?.generalImagery?.length) {
            setImage(item.generalImagery[0]?.fileName)
        } else {
            const firstVariant = item.variants[0];
            setImage(firstVariant?.speciesGeneralImagery[0]?.fileName)
        }
    }, [item])

    return <>
        {item && image &&
            <div className='item-product-wrapper'>
                <div onMouseLeave={() => imageLeaveHandler(image)} onMouseEnter={() => imageHoverHandler(secondImage ? secondImage : image)} onClick={() => { setItem(item) }} className='item-product'>
                    <div className={`item-tag has-tag`}>
                        <div className="pill bark shimmer">Table Builder</div>
                    </div>

                    {image &&

                        <motion.div
                            key={image}
                            variants={variants}
                            animate={'show'}
                            initial={'hide'}
                            className='item-img-container'
                        >
                            <div className='item-img'>
                                <div className='image-loader'>
                                    <div className="loader"></div>
                                </div>
                                <img alt='' src={`${process.env.REACT_APP_WEBSITE_API}/api/images/optimize?filePath=images/${folder}/${image}&width=600&height=800&quality=90&format=webp`} />
                            </div>
                        </motion.div>

                    }
                    <div className={`item-details ${item.lightText ? "light" : ""}`}>
                        <p>Divergence Dining Table Builder</p>
                    </div>
                </div>
            </div>
        }

    </>
}

export default DivergenceItem;

export const variants = {
    show: {
        opacity: 1,
        y: 0,
        transition: {
            ease: 'easeIn',
            duration: 0.5
        }
    },
    hide: {
        y: 0,
        opacity: 0,
        transition: {
            ease: 'easeOut',
            duration: 0.5
        }
    }
};